import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
@Component({
  selector: 'app-gestiones-pdfs',
  templateUrl: './gestiones-pdfs.component.html',
  styleUrls: ['./gestiones-pdfs.component.scss']
})
export class GestionesPdfsComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  @Input() politicas: any
  @Input() datacliente: any
  constructor() { }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
  generatePdfPreca(participante){

  }
  generatePdfDictamen() {

  }
}
